/**
 * Eén meerkeuzevraag: de vraag, en de opties A tot en met D om aan te klikken.
 */
import React from 'react';
import { stijlen } from '../stijlen';

const optie = {
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  marginBottom: 8,
  border: '2px solid var(--lijn)',
  borderRadius: 8,
  cursor: 'pointer',
  transition: 'all 0.2s',
};
const gekozenOptie = { borderColor: 'var(--accent)', background: 'rgba(74, 144, 164, 0.1)' };

export function MeerkeuzeVraag({ nummer, vraag, gekozen, onKies }) {
  return (
    <div style={stijlen.vraagBlok}>
      <h4 style={stijlen.vraagNummer}>Vraag {nummer}</h4>
      <p style={stijlen.vraagTekst}>{vraag.vraag}</p>
      {Object.entries(vraag.opties).map(([letter, tekst]) => (
        <div key={letter} style={{ ...optie, ...(gekozen === letter ? gekozenOptie : {}) }} onClick={() => onKies(letter)}>
          <input type="radio" name={`mc-${vraag.id}`} checked={gekozen === letter} onChange={() => {}} style={{ marginRight: 12 }} />
          <strong style={{ marginRight: 8 }}>{letter}.</strong>
          <span>{tekst}</span>
        </div>
      ))}
    </div>
  );
}
